import LiveRewardsBasicList from './List';

const LiveRewardsBasicIndex = {
  LiveRewardsBasicList,
};

export default LiveRewardsBasicIndex;
